export interface FeatureHintActiveTarget {
  id: string;
  ringClassName?: string;
}

type Listener = () => void;

const listeners = new Set<Listener>();

let activeHint: FeatureHintActiveTarget | null = null;
const targets = new Map<string, HTMLElement>();
let targetsVersion = 0;

const emitChange = (): void => {
  listeners.forEach((listener) => listener());
};

export const subscribeFeatureHints = (listener: Listener): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const getActiveFeatureHint = (): FeatureHintActiveTarget | null =>
  activeHint;

export const setActiveFeatureHint = (
  hint: FeatureHintActiveTarget | null
): void => {
  activeHint = hint;
  emitChange();
};

export const getFeatureHintTarget = (id: string): HTMLElement | undefined =>
  targets.get(id);

export const hasFeatureHintTarget = (id: string): boolean => targets.has(id);

export const getRegisteredFeatureHintIds = (): ReadonlySet<string> =>
  new Set(targets.keys());

export const getFeatureHintTargetsVersion = (): number => targetsVersion;

export const registerFeatureHintTarget = (
  id: string,
  element: HTMLElement | null
): void => {
  if (element) {
    targets.set(id, element);
  } else {
    targets.delete(id);
  }

  targetsVersion += 1;
  emitChange();
};
